import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import { h5NavigateTo } from "../../utils/miniProgramEnv";
import {
  parseCsRenewalProductCardContent,
  truncateCsRenewalDescription,
} from "./csRenewalProductCardUtil";

export const CsRenewalProductCard: React.FC<{ content: string }> = ({ content }) => {
  const navigate = useNavigate();
  const payload = useMemo(() => parseCsRenewalProductCardContent(content), [content]);

  if (!payload) {
    return <span>[续费提醒]</span>;
  }

  const posterUrl = resolveAppMediaUrl(payload.posterUrl) ?? payload.posterUrl ?? "";
  const description = truncateCsRenewalDescription(payload.productDescription);
  const priceLabels = (payload.priceLabels ?? []).filter((x) => x?.trim());

  const onSubscribe = () => {
    const path = payload.subscribePathH5?.trim();
    if (!path) return;
    h5NavigateTo(navigate, path);
  };

  return (
    <div className="space-cs-renewal-card">
      {posterUrl ? <img src={posterUrl} alt="" className="space-cs-renewal-card-image" /> : null}
      <div className="space-cs-renewal-card-main">
        <div className="space-cs-renewal-card-title">{payload.productName ?? "产品续费"}</div>
        {description ? <div className="space-cs-renewal-card-desc">{description}</div> : null}
        <div className="space-cs-renewal-card-foot">
          <div className="space-cs-renewal-card-prices">
            {priceLabels.map((label) => (
              <span key={label} className="space-cs-renewal-card-price">
                {label}
              </span>
            ))}
          </div>
          <button type="button" className="space-cs-renewal-card-action" onClick={onSubscribe}>
            立即订阅
          </button>
        </div>
      </div>
    </div>
  );
};

export default CsRenewalProductCard;
